import React from 'react';
import { Button, CardText, Card, CardHeader, Row, CardTitle, Col, Container } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink, Input } from 'reactstrap';
import Select from 'react-select';
import './css/ListaCargaVicerrector.css';
import Image from 'react-bootstrap/Image';
import { withRouter } from 'react-router-dom';
import './css/fonts.css';
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";

function importAll(r) {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images
}

const images = importAll(require.context('./icons', false, /\.(png|jpe?g|svg)$/));

const options = [
    { value: '0', label: 'Todos' },
    { value: '1', label: 'Atendidas' },
    { value: '2', label: 'Parcialmente Atendidas' },
    { value: '3', label: 'Pendientes' }
]

const optionsDelegacion = [
    { value: '0', label: 'Todos' },
    { value: '1', label: 'Delegados' },
    { value: '2', label: 'No delegados' }
]


class ListaCargaVicerrector extends React.Component {
    constructor(props) {
        super(props);
        const cargaList = this.props.carga;
        const roles = this.props.rol
        //console.log(cargaList);
        this.state = {
            loading: true,
            actividades: cargaList,
            actividadesMutar: cargaList,
            currentActividades: [],
            currentPage: 1,
            totalPages: null,
            delegacionSelect: 'Todos',
            tipoSelect: 'Todos',
            filterDelegacion: 0,            
            filterTipo: 0,
            roles: roles,            
            totalPageP: Math.ceil(cargaList.length / 10),
            actualPage: 1,
            limite: 10,
            siblingCount: 1,
        };
        this.page = this.page.bind(this);
        this.onChangeLimite = this.onChangeLimite.bind(this);
        //console.log(window.location.pathname);
    }

    returnStatus = act => {
        return (act.accionesIngresadas + act.accionesIngresadasCoor === 0 || this.state.filterTipo === 3) || act.strEstado == "PZ" ? "pe" :
            (act.accionesIngresadas + act.accionesIngresadasCoor == act.cantAcciones + act.cantAccionesCoor || this.state.filterTipo === 1) || act.strEstado == "AT" ? "at" : "pt"
    }

    redirect = idPersona => {
        /*console.log('alola')*/
        this.props.history.push('/profesorVicerrector/' + idPersona)
    }

    page(num) {
        if (this.state.actualPage !== num) {
            this.setState({
                actualPage: num
            });
        }
    }

    pagePrevious() {
        if (this.state.actualPage !== 1) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p - 1
            });
        }
    }

    pageNext() {
        if (this.state.actualPage !== this.state.totalPageP) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p + 1
            });
        }
    }

    youAreMySibling(num) {
        let actualPage = this.state.actualPage;
        let sibling = this.state.siblingCount;
        let total = this.state.totalPageP;
        let valor = false;
        if (num === actualPage || num - sibling === actualPage || num + sibling === actualPage) {
            valor = true;
        }
        if (actualPage === 1 && (num - 1 === actualPage || num - 2 === actualPage || num - 3 === actualPage) ){
            valor = true;
        }
        if (actualPage === 2 && (num - 1 === actualPage || num - 2 === actualPage )) {
            valor = true;
        }
        if (actualPage === total && (num + 1 === actualPage || num + 2 === actualPage || num + 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === total - 1 && (num + 1 === actualPage || num + 2 === actualPage)) {
            valor = true;
        }
        /*console.log(num, valor);*/
        return valor;
    }

    handleChangeTipo = selectedOption => {
        /*console.log(`Option selected:`, selectedOption);*/

        const value = parseInt(selectedOption.value);
        this.setState({ filterTipo: value, tipoSelect: selectedOption.label });
        const { filterDelegacion } = this.state;
        let mapeo = this.state.actividades;
        /*console.log("MAPEO", mapeo);*/
        if (filterDelegacion === 1) {
            mapeo = mapeo.filter(x => x.cantAccionesCoor > 0)
            if (value === 1) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor == x.accionesIngresadasCoor);
            }
            else if (value === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadasCoor === 0 && x.cantAccionesCoor !== 0 && x.cantAccionesCoor > 0);
            }
            else if (value === 2) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor > 1 && x.accionesIngresadasCoor >= 1);
            }
        }
        else if (filterDelegacion === 2) {
            if (filterDelegacion === 2)
                mapeo = mapeo.filter(x => x.cantAccionesCoor === 0)
            if (value === 1) {
                mapeo = mapeo.filter(x => x.cantAcciones == x.accionesIngresadas && x.cantAcciones > 0);
            }
            else if (value === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadas === 0 && x.cantAcciones !== 0);
            }
            else if (value === 2) {
                mapeo = mapeo.filter(x => x.cantAcciones > 1 && x.accionesIngresadas >= 1 && x.cantAcciones > x.accionesIngresadas);
            }
        } else if (filterDelegacion === 0) {
            if (value === 1) {
                mapeo = mapeo.filter(x => x.cantAcciones + x.cantAccionesCoor == x.accionesIngresadas + x.accionesIngresadasCoor && x.cantAcciones > 0);
            }
            else if (value === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadas + x.accionesIngresadasCoor === 0 && x.cantAcciones + x.cantAccionesCoor !== 0);
            }
            else if (value === 2) {
                mapeo = mapeo.filter(x => x.cantAcciones + x.cantAccionesCoor > 1 && x.accionesIngresadas + x.accionesIngresadasCoor >= 1 && x.cantAcciones + x.cantAccionesCoor > x.accionesIngresadas + x.accionesIngresadasCoor);
            }
        }
        
        this.setState({ actividadesMutar: mapeo, actualPage: 1 });
        this.reLoadTotalPage(mapeo.length, this.state.limite);
    };

    handleChangeNombre = selectedOption => {
        const { value, label } = selectedOption;
        let mapeo = []
        if (value === 0) {           
            this.handleChangeTipo({ label: "Todos", value: this.state.filterTipo });
        } else {
            mapeo = this.state.actividades.filter(x => x.intIdPersona === value);            
            this.setState({ actividadesMutar: mapeo, actualPage: 1 });
            this.reLoadTotalPage(mapeo.length, this.state.limite);
        }

    };

    handleChangeUnidad = selectedOption => {
        const { value, label } = selectedOption;
        let mapeo = []
        if (value === 0) {
            this.handleChangeTipo({ label: "Todos", value: this.state.filterTipo });
        } else {
            mapeo = this.state.actividades.filter(x => x.strUnidad === value);
            this.setState({ actividadesMutar: mapeo, actualPage: 1 });
            this.reLoadTotalPage(mapeo.length, this.state.limite);
        }

    };

    handleChangeDelegacion = selectedOption => {
        /*console.log(`Option selected:`, selectedOption);*/

        const value = parseInt(selectedOption.value);
        this.setState({ filterDelegacion: value, delegacionSelect: selectedOption.label });
        const { filterTipo } = this.state;
        let mapeo = this.state.actividades;
        if (value === 1) {
            mapeo = mapeo.filter(x => x.cantAccionesCoor > 0)
            if (filterTipo === 1) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor == x.accionesIngresadasCoor);
            }
            else if (filterTipo === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadasCoor === 0 && x.cantAccionesCoor !== 0);
            }
            else if (filterTipo === 2) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor > 1 && x.accionesIngresadasCoor >= 1);
            }
        }
        else if (value === 2 || value === 0) {
            if (value === 2)
                mapeo = mapeo.filter(x => x.cantAccionesCoor === 0)
            if (filterTipo === 1) {
                mapeo = mapeo.filter(x => x.cantAcciones == x.accionesIngresadas);
            }
            else if (filterTipo === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadas === 0 && x.cantAcciones !== 0);
            }
            else if (filterTipo === 2) {
                mapeo = mapeo.filter(x => x.cantAcciones > 1 && x.accionesIngresadas >= 1 && x.cantAcciones > x.accionesIngresadas);
            }
        }
        //console.log("FILTER TIPO: ", filterTipo)
        //console.log("MAPEO POS FILTER TIPO: ", mapeo)
        //const currentActividades = mapeo.slice(0, 0 + limite);
        //console.log(currentActividades);
        //this.setState({ currentActividades: currentActividades, totalRecords: currentActividades.length, actividadesMutar: mapeo });
        this.setState({ actividadesMutar: mapeo, actualPage: 1 });
        this.reLoadTotalPage(mapeo.length, this.state.limite);
    };

    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageP: Math.ceil(lenActividades / limite) });
        /*console.log('Total Paginas: ',this.state.totalPageA);*/
    }

    onChangeLimite(event) {
        //console.log('Cambio limite');
        //console.log(event.target.value);
        var num = event.target.value;
        this.setState({ limite: num, actualPage: 1 });
        this.reLoadTotalPage(this.state.actividadesMutar.length, num);
    }

    render() {
        let { actividadesMutar, actividades, filterTipo } = this.state;

        let xmCol = 'col-2';

        let jumpP = '<<';
        let jumpN = '>>';

        if (actividadesMutar !== null) {
            /*console.log("OG", actividadesMutar)*/
            actividadesMutar.sort((a, b) => {
                if (a.strEstado > b.strEstado) { return -1; }
                if (a.strEstado < b.strEstado) { return 1; }
            })
            /*console.log("UPDATED", actividadesMutar)*/
        }

        let nombresText = actividadesMutar === null || Object.keys(actividadesMutar).length === 0 ? [] : actividadesMutar.map(x => ({ label: x.strNombreCompleto, value: x.intIdPersona }));

        let unidades = actividadesMutar === null || Object.keys(actividadesMutar).length === 0 ? []
            : actividadesMutar.map(x => (x.strUnidad));

        const unicos = [];

        for (var i = 0; i < unidades.length; i++) {

            const elemento = unidades[i];

            if (!unicos.includes(unidades[i])) {
                unicos.push(elemento);
            }
        }

        let unidadText = [];

        for (var i = 0; i < unicos.length; i++) {
            const elemento = unicos[i];
            unidadText.push({ label: elemento, value: elemento })
        }

        /*console.log(filterTipo)*/
        if (filterTipo === 0) {
            /*console.log("OG", actividadesMutar)*/
            actividadesMutar.sort((a, b) => {
                if (a.strEstado > b.strEstado) { return -1; }
                if (a.strEstado < b.strEstado) { return 1; }
            })
            /*console.log("UPDATED", actividadesMutar)*/
        }

        nombresText.push({ label: "Ninguna", value: 0 });

        unidadText.push({ label: "Ninguna", value: 0 });        

        //console.log(unidadText);

        let pagesA = [];
        for (let i = 1; i <= this.state.totalPageP; i++) {
            pagesA.push(<></>);
        }

        return (
            <>
                <Row>
                    <Col xs="4">
                        <label>
                            Nombre/Apellido:
                        </label>
                        <Select name="nombre"
                            options={nombresText}
                            value={this.state.nombre}
                            onChange={this.handleChangeNombre} />
                    </Col>
                    <Col xs="4">
                        
                    </Col>
                    <Col xs="4">
                        {this.state.roles.includes('VICERRECTOR') ?
                            <>
                                <label>
                                    Unidad Acad&eacute;mica
                                </label>
                                <Select name="unidad"
                                    options={unidadText}
                                    value={this.state.unidad}
                                    onChange={this.handleChangeUnidad} />
                            </>
                            : <></>}
                    </Col>
                </Row>
                <br />
                <Row hidden={actividadesMutar.length === 0} id={'newPagination'}>
                    <Col xs="8"></Col>                    
                    <Col>
                        <Pagination hidden={pagesA.length < 1 } >                            
                            <PaginationItem active={this.state.actualPage === 1} onClick={() => { this.page(1); }}>
                                <PaginationLink>
                                    {1}
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === 1} onClick={() => { this.pagePrevious(); }}>
                                <PaginationLink previous />
                            </PaginationItem>
                            {pagesA.map((page, i) =>
                            (
                                <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageP || !this.youAreMySibling(i+1)} active={this.state.actualPage === i + 1} onClick={() => { this.page(i + 1); }}>
                                    <PaginationLink>
                                        {i + 1}
                                    </PaginationLink>
                                </PaginationItem>)
                            )}
                            <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === this.state.totalPageP } onClick={() => { this.pageNext(); }}>
                                <PaginationLink next />
                            </PaginationItem>
                            <PaginationItem hidden={this.state.totalPageP === 1} active={this.state.actualPage === this.state.totalPageP} onClick={() => { this.page(this.state.totalPageP); }}>
                                <PaginationLink>
                                    {this.state.totalPageP}
                                </PaginationLink>
                            </PaginationItem>                            
                        </Pagination>
                    </Col>
                    <Col xs="1">
                        <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                            <option hidden key={"sel-1"} selected={1 == this.state.limite} value={1}>{1}</option>
                            <option key={"sel-5"} selected={5 == this.state.limite} value={5}>{5}</option>
                            <option key={"sel-10"} selected={10 == this.state.limite} value={10}>{10}</option>
                            <option key={"sel-25"} selected={25 == this.state.limite} value={25}>{25}</option>
                        </Input>
                    </Col>
                </Row>
                <div id="cartasListDecano">
                    <Card>
                        <CardHeader style={{}} hidden={actividadesMutar.length === 0} >
                            <Container fluid>
                                <Row>
                                    <Col className='col-1'>
                                    </Col>
                                    <Col className='col-5'>
                                        Profesor
                                    </Col>
                                    <Col className='col-4'>
                                        Unidad Acad&eacute;mica
                                    </Col>
                                    <Col className={'col-2'}>
                                        Estado
                                    </Col>
                                </Row>
                            </Container>
                        </CardHeader>
                    </Card>
                    {actividadesMutar.map((profesor, i) =>
                        <Card hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                            <CardHeader>
                                <Button className="btnProf" onClick={() => this.redirect(profesor.intIdPersona)}>

                                    <Container fluid>
                                        <Row>
                                            <Col className='col-1'>
                                                <Image src={"https://talentohumano.espol.edu.ec/imgEmpleado/" + profesor.strCedula + ".jpg"}
                                                    onError={(e) => (e.target.onerror = null, e.target.src = images['user2.png'].default)}
                                                    style={{ width: 60, height: 60, borderRadius: '50%', overflow: 'hidden', borderWidth: 3, borderColor: 'red', }} />
                                            </Col>
                                            <Col className='col-5' style={{ textAlign: 'center' }}>
                                                {profesor.strNombreCompleto}
                                            </Col>
                                            <Col className='col-4' style={{ textAlign: 'center' }}>
                                                {profesor.strUnidad}
                                            </Col>
                                            <Col className={xmCol + " alolaList " + this.returnStatus(profesor)}><strong>{
                                                profesor.strEstado == "PZ" ? "Pendiente" :
                                                profesor.strEstado == "AT" ? "Atendido" :
                                                profesor.strEstado == "PV" ? "Verificar"
                                                : "Devuelto"
                                            }</strong></Col>

                                        </Row>
                                    </Container>

                                </Button>

                            </CardHeader>
                        </Card>
                    )}
                    {actividadesMutar.length === 0 ? 
                        <Card body className="text-center py-3">No hubo resultados</Card>
                        : <></>}
                </div>
                <br />
                <Row hidden={actividadesMutar.length === 0}>
                    <Col xs="8"></Col>                    
                    <Col>
                        <Pagination hidden={pagesA.length < 1} >
                            <PaginationItem active={this.state.actualPage === 1} onClick={() => { this.page(1); }}>
                                <PaginationLink>
                                    {1}
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === 1} onClick={() => { this.pagePrevious(); }}>
                                <PaginationLink previous />
                            </PaginationItem>
                            {pagesA.map((page, i) =>
                            (
                                <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageP || !this.youAreMySibling(i + 1)} active={this.state.actualPage === i + 1} onClick={() => { this.page(i + 1); }}>
                                    <PaginationLink>
                                        {i + 1}
                                    </PaginationLink>
                                </PaginationItem>)
                            )}
                            <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === this.state.totalPageP} onClick={() => { this.pageNext(); }}>
                                <PaginationLink next />
                            </PaginationItem>
                            <PaginationItem hidden={this.state.totalPageP === 1} active={this.state.actualPage === this.state.totalPageP} onClick={() => { this.page(this.state.totalPageP); }}>
                                <PaginationLink>
                                    {this.state.totalPageP}
                                </PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </Col>
                    <Col xs="1">
                        <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                            <option hidden key={"sel-1"} selected={1 == this.state.limite} value={1}>{1}</option>
                            <option key={"sel-5"} selected={5 == this.state.limite} value={5}>{5}</option>
                            <option key={"sel-10"} selected={10 == this.state.limite} value={10}>{10}</option>
                            <option key={"sel-25"} selected={25 == this.state.limite} value={25}>{25}</option>
                        </Input>
                    </Col>
                </Row>
            </>
        )
    }
}

export default withRouter(ListaCargaVicerrector);